export const selfDriveConditions = [
  { title: "Without Driver", value: "without_driver" },
  { title: "With Driver", value: "with_driver" },
];
